import { render, staticRenderFns } from "./TheHeaderProfileCards.component.vue?vue&type=template&id=1ce5a5d8"
import script from "./TheHeaderProfileCards.component.vue?vue&type=script&lang=js"
export * from "./TheHeaderProfileCards.component.vue?vue&type=script&lang=js"
import style0 from "./TheHeaderProfileCards.component.vue?vue&type=style&index=0&id=1ce5a5d8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports